import { TextStyle } from 'spa/components/typography'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles'

const PreferencesListItem = ({
  autoselected,
  label,
  selected,
  required,
  handleClick,
  tooltip,
}) => {
  return (
    <div
      className={classNames('cleanButton', styles.cell, {
        [styles.cellSelected]: selected || autoselected,
      })}
      onClick={required ? null : handleClick}
      tooltip={tooltip}
    >
      <TextStyle className={styles.tagText}>{label}</TextStyle>
    </div>
  )
}

PreferencesListItem.propTypes = {
  autoselected: PropTypes.bool,
  handleClick: PropTypes.func,
  label: PropTypes.string,
  required: PropTypes.bool,
  selected: PropTypes.bool,
  tooltip: PropTypes.string,
}

export default PreferencesListItem
